interface SlotIdentity {
  venue_id: number;
  restaurant: string;
  party_size: number;
  date: string;
  available_time: string;
  slot_type?: string;
}

/** Keep the first bookable link per sitting, with party sizes kept separate. */
export function uniqueBookableSlots<T extends SlotIdentity>(slots: T[]): T[] {
  const seen = new Set<string>();
  return slots.filter(slot => {
    if (slot.slot_type && slot.slot_type !== 'book') return false;
    const key = JSON.stringify([
      slot.venue_id, slot.restaurant, slot.party_size, slot.date, slot.available_time,
    ]);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
